document.addEventListener('DOMContentLoaded', function() {
    function toogleArloBerezia(){
        const arloaSelect = document.getElementById('arloa_id');
        const besteakDiv = document.getElementById('arlo_berezitua_div'); // Asegúrate de que tu div tenga este id
        if (!arloaSelect) return;
        let hasBesteak = false;
        for (let i = 0; i < arloaSelect.selectedOptions.length; i++) {
            if (arloaSelect.selectedOptions[i].text.trim() === 'Besteak') {
                hasBesteak = true;
                break;
            }
        }
        if (hasBesteak) {
            if (besteakDiv) besteakDiv.style.display = 'block';
        } else {
            if (besteakDiv) besteakDiv.style.display = 'none';
            const arloaBer = document.getElementById('arlo_berezitua');
            if (arloaBer) arloaBer.value = '';
        }
    }

    const arloaSelect = document.getElementById('arloa_id'); 
    if (arloaSelect) {
        toogleArloBerezia();
        arloaSelect.addEventListener('change', toogleArloBerezia);
    }

    function initCustomMultiSelect(selectId) {
        const originalSelect = document.getElementById(selectId);
        if (!originalSelect) return;
        originalSelect.style.display = 'none';

        const wrapper = document.createElement('div');
        wrapper.className = 'custom-multiselect-wrapper';
        
        const chipsContainer = document.createElement('div');
        chipsContainer.className = 'custom-multiselect-chips';

        const inputBtn = document.createElement('div');
        inputBtn.className = 'custom-multiselect-input';
        inputBtn.textContent = 'Aukeratu arloak...';

        const dropdown = document.createElement('div');
        dropdown.className = 'custom-multiselect-dropdown';

        wrapper.appendChild(chipsContainer);
        wrapper.appendChild(inputBtn);
        wrapper.appendChild(dropdown);

        originalSelect.parentNode.insertBefore(wrapper, originalSelect.nextSibling);

        const options = Array.from(originalSelect.options);
        options.forEach(opt => {
            if(!opt.value) return; 
            const div = document.createElement('div');
            div.className = 'custom-multiselect-option';
            div.textContent = opt.textContent;
            div.dataset.value = opt.value;
            if (opt.selected) div.classList.add('selected');

            div.addEventListener('click', function(e) {
                e.stopPropagation();
                if (div.classList.contains('selected')) return;
                opt.selected = true;
                div.classList.add('selected');
                updateChips();
                originalSelect.dispatchEvent(new Event('change'));
            });
            dropdown.appendChild(div);
        });

        function updateChips() {
            chipsContainer.innerHTML = '';
            options.forEach(opt => {
                if (opt.selected && opt.value) {
                    const chip = document.createElement('div');
                    chip.className = 'custom-multiselect-chip';
                    chip.textContent = opt.textContent;

                    const closeBtn = document.createElement('span');
                    closeBtn.textContent = '×';
                    closeBtn.addEventListener('click', function(e) {
                        e.stopPropagation();
                        opt.selected = false;
                        const dropdownItem = dropdown.querySelector(`.custom-multiselect-option[data-value="${opt.value}"]`);
                        if (dropdownItem) dropdownItem.classList.remove('selected');
                        updateChips();
                        originalSelect.dispatchEvent(new Event('change'));
                    });

                    chip.appendChild(closeBtn);
                    chipsContainer.appendChild(chip);
                }
            });
        }

        inputBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            dropdown.classList.toggle('open');
        });

        document.addEventListener('click', function() {
            dropdown.classList.remove('open');
        });

        updateChips();
    }
    
    initCustomMultiSelect('arloa_id');
});
